<template>
  <div class="lidaCard ledger-block">
    <ButtonTool v-if="$route.name != 'assortLedgerSearch'">
    </ButtonTool>
    <router-view :key="$route.fullPath"></router-view>
    <!-- <router-view name="report4mlgp" v-if="showstate"></router-view> -->
    <BackBottom ></BackBottom>
    <BackTop :height="100" :right="85"></BackTop>
  </div>
</template>
<script>
import ButtonTool from '@/components/tool/ButtonTool.vue'
export default {
  components:{
    ButtonTool
  }
}
</script>